/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import InformationButton from "../../../components/molecules/InformationButton"
import { getCountryFromLanguage } from "../../../core/service/BusinessLogicService"

/* Utils */
import { loc } from "../../../core/utils"

/* Forms controls & validation */
import NumberField from "../../../form/NumberField"
import Select from "../../../form/Select"
import TextField from "../../../form/TextField"
import Bloc from "./Bloc"
import React from "react"
import { Col, FormGroup, Row } from "react-bootstrap"
import {FINANCERS} from "../../../constants";

export default function BudgetBloc(props) {
  const { tunnelData, values, blocFields, completedFields } = props
  const { clientPageConfiguration } = tunnelData
  const { budget } = clientPageConfiguration

  return (
    <Bloc hide={!budget} name="My budget" completedFields={completedFields} totalFieldsNumber={blocFields.length}>
      <div className="hard-shadow-white-block">
        {budget?.includes("netMonthlyIncome") && (
          <>
            <Row>
              <Col lg={6}>
                <NumberField
                  noFormGroup
                  name="budget.netMonthlyIncome"
                  label={loc("Your net monthly income")}
                  placeholder="€"
                  inputmode="numeric">
                  { FINANCERS.EVOLLIS === tunnelData.data.order.financerType && (<InformationButton overlayText={loc("Net monthly income tooltip")} />)}
                </NumberField>
              </Col>
              {values.budget.showIncomeOrigin && budget?.includes("incomeOrigin") && (
                <Col lg={6}>
                  <Select
                    noFormGroup
                    name="budget.incomeOrigin"
                    label={loc("income Origin")}
                    url={
                      tunnelData.apiUrl +
                      "middle-business-service/api/v2/repository/income-origins/" +
                      getCountryFromLanguage(tunnelData.data.order.orderLanguageTag)
                    }
                    token={tunnelData.access_token}
                  />
                </Col>
              )}
              {values.budget.showDetailsIncome && budget?.includes("incomeOrigin") && (
                <Col lg={6}>
                  <TextField name="budget.detailOfIncome" label={loc("detail Of Income")} trimOnBlur={true} />
                </Col>
              )}
              <Col xs={6}>
                <Select
                  noFormGroup
                  label={" "}
                  hidden={!budget?.includes("numberMonthsIncome")}
                  name="budget.numberMonthsIncome"
                  disabled={
                    tunnelData.data.order.simplifiedJourneyEnabled &&
                    !tunnelData?.simplifiedJourneyInputConfiguration?.budget?.numberMonthsIncome?.editable
                  }
                  url={
                    tunnelData.apiUrl +
                    "middle-business-service/api/v2/repository/income-number-month/" +
                    getCountryFromLanguage(tunnelData.data.order.orderLanguageTag)
                  }
                  token={tunnelData.access_token}
                />
              </Col>
            </Row>
          </>
        )}
        {budget?.includes("otherIncome") && (
          <FormGroup>
            <Row noGutters>
              <Col>
                <NumberField
                  noFormGroup
                  name="budget.otherIncome"
                  label={loc("Other monthly income")}
                  placeholder="€"
                  inputmode="numeric"
                  disabled={
                    tunnelData.data.order.simplifiedJourneyEnabled &&
                    !tunnelData?.simplifiedJourneyInputConfiguration?.budget?.otherIncome.editable
                  }
                >
                  <InformationButton overlayText={loc("Property income or alimony paid")} />
                </NumberField>
              </Col>
            </Row>
          </FormGroup>
        )}
        {budget?.includes("rent") && (
          <FormGroup className={"mt-3"}>
            <Row noGutters>
              <Col>
                <NumberField
                  noFormGroup
                  name="budget.rent"
                  label={loc("Your share of monthly charges")}
                  placeholder="€"
                  inputmode="numeric"
                  disabled={
                    tunnelData.data.order.simplifiedJourneyEnabled &&
                    !tunnelData?.simplifiedJourneyInputConfiguration?.budget?.rent.editable
                  }
                >
                  {  FINANCERS.EVOLLIS === tunnelData.data.order.financerType  ? (
                    <InformationButton overlayText={loc("Rent or mortgage EVO")} />
                  ) : (
                    <InformationButton overlayText={loc("Rent or mortgage")} />
                  )}                </NumberField>
              </Col>
            </Row>
          </FormGroup>
        )}
        {budget?.includes("otherCharges") && (
          <FormGroup>
            <Row noGutters>
              <Col>
                <NumberField
                  noFormGroup
                  name="budget.otherCharges"
                  label={loc("Other monthly charges")}
                  placeholder="€"
                  inputmode="numeric"
                  disabled={
                    tunnelData.data.order.simplifiedJourneyEnabled &&
                    !tunnelData?.simplifiedJourneyInputConfiguration?.budget?.otherCharges.editable
                  }
                >
                  <InformationButton overlayText={loc("Credit (excluding mortgage) and / or alimony paid")} />
                </NumberField>
              </Col>
            </Row>
          </FormGroup>
        )}
      </div>
    </Bloc>
  )
}
